import { AuthState } from '@/features/auth/auth.def.ts'
import { authSlice } from '@/features/auth/auth.slice.ts'
import { nrba } from '@/new-relic-init.ts'
import { AppEnv } from '@/utils/env.ts'

interface PersistedState {
  auth: AuthState
}

export function preloadState(): PersistedState {
  const state: Partial<PersistedState> = {}

  const previousAuthStateStr = localStorage.getItem(authSlice.name)
  if (previousAuthStateStr) {
    const authState = JSON.parse(previousAuthStateStr) as AuthState
    const isValidToken = authState.user?.exp ? authState.user.exp * 1000 > Date.now() : false
    if (!isValidToken || authState.user?.env !== AppEnv.env) {
      return state as PersistedState
    }

    if (authState.user?.name) {
      nrba.setUserId(authState.user.name)
    }
    state.auth = authState
  }

  return state as PersistedState
}
